import { render, staticRenderFns } from "./ViewMedicationUnit.vue?vue&type=template&id=67591cd2&scoped=true"
import script from "./ViewMedicationUnit.vue?vue&type=script&lang=js"
export * from "./ViewMedicationUnit.vue?vue&type=script&lang=js"
import style0 from "./ViewMedicationUnit.vue?vue&type=style&index=0&id=67591cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67591cd2",
  null
  
)

export default component.exports